import { MallAxiosInterceptor } from "api/core/consts";

export const orderReply = {
  getMallOrderReply: (mallOrderReplyId) => MallAxiosInterceptor.get('mallOrderReply/' + mallOrderReplyId),
  searchMallOrderReply: (paging, body) => MallAxiosInterceptor.post('mallOrderReply/search' + paging, body),
  createMallOrderReply: (body) => MallAxiosInterceptor.post('mallOrderReply', body),
  updateMallOrderReply: (mallOrderReplyId, body) => MallAxiosInterceptor.put('mallOrderReply/' + mallOrderReplyId, body),
  deleteMallOrderReply: (mallOrderReplyId) => MallAxiosInterceptor.delete('mallOrderReply/' + mallOrderReplyId),
};
